import React from 'react';
import { CheckCircleIcon, ClockIcon, AlertCircleIcon, TrendingUpIcon, UsersIcon, ShieldCheckIcon } from 'lucide-react';
import { formatNaira } from '../../utils/format';
export function DashboardModule({
  role
}: {
  role: string;
}) {
  const stats = [{
    label: 'Total Active Plans',
    value: '12,450',
    change: '+12%',
    positive: true,
    icon: ShieldCheckIcon,
    color: 'emerald'
  }, {
    label: 'Contributions (MTD)',
    value: formatNaira(45200000),
    change: '+8.5%',
    positive: true,
    icon: TrendingUpIcon,
    color: 'teal'
  }, {
    label: 'Active Claims',
    value: '142',
    change: '-3%',
    positive: true,
    icon: AlertCircleIcon,
    color: 'amber'
  }, {
    label: 'Total Users',
    value: '45,892',
    change: '+5%',
    positive: true,
    icon: UsersIcon,
    color: 'blue'
  }];
  const recentClaims = [{
    id: 'CLM-8492',
    user: 'Adaeze Okonkwo',
    product: 'AutoGuard',
    amount: 500000,
    status: 'Under Review'
  }, {
    id: 'CLM-8491',
    user: 'Chinedu Eze',
    product: 'Wellness Plan',
    amount: 45000,
    status: 'Submitted'
  }, {
    id: 'CLM-7102',
    user: 'Adaeze Okonkwo',
    product: 'TravelGuard',
    amount: 120000,
    status: 'Settled'
  }];
  return <div className="space-y-6" data-id="element-304">
      <div className="bg-[#0D3B3B] rounded-2xl p-6 text-white shadow-lg overflow-hidden relative" data-id="element-305">
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -mr-20 -mt-20 pointer-events-none" data-id="element-306" />
        <h2 className="text-2xl font-bold mb-1" data-id="element-307">Welcome back, Admin</h2>
        <p className="text-emerald-400 text-sm font-medium" data-id="element-308">
          Logged in as {role}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-309">
        {stats.map((stat, idx) => <div key={idx} className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm flex flex-col" data-id="element-310">
            <div className="flex justify-between items-start mb-4" data-id="element-311">
              <div className={`w-10 h-10 rounded-xl bg-${stat.color}-50 flex items-center justify-center text-${stat.color}-600`} data-id="element-312">
                <stat.icon className="w-5 h-5" data-id="element-313" />
              </div>
              <span className={`text-xs font-bold px-2 py-1 rounded-full ${stat.positive ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700'}`} data-id="element-314">
                {stat.change}
              </span>
            </div>
            <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-315">
              {stat.label}
            </p>
            <h3 className="text-2xl font-bold text-[#0D3B3B]" data-id="element-316">{stat.value}</h3>
          </div>)}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-317">
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden" data-id="element-318">
          <div className="px-6 py-5 border-b border-gray-100 flex justify-between items-center" data-id="element-319">
            <h3 className="font-bold text-[#0D3B3B]" data-id="element-320">Recent Claims</h3>
          </div>
          <div className="overflow-x-auto" data-id="element-321">
            <table className="w-full text-left" data-id="element-322">
              <thead data-id="element-323">
                <tr className="bg-gray-50/50 text-xs uppercase tracking-wider text-gray-500 font-semibold" data-id="element-324">
                  <th className="px-6 py-3" data-id="element-325">Claim ID</th>
                  <th className="px-6 py-3" data-id="element-326">User</th>
                  <th className="px-6 py-3" data-id="element-327">Amount</th>
                  <th className="px-6 py-3" data-id="element-328">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-329">
                {recentClaims.map(claim => <tr key={claim.id} className="hover:bg-gray-50" data-id="element-330">
                    <td className="px-6 py-4 text-sm font-bold text-[#0D3B3B]" data-id="element-331">
                      {claim.id}
                    </td>
                    <td className="px-6 py-4" data-id="element-332">
                      <div className="text-sm font-bold text-[#0D3B3B]" data-id="element-333">
                        {claim.user}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-334">
                        {claim.product}
                      </div>
                    </td>
                    <td className="px-6 py-4 text-sm font-bold text-[#0D3B3B]" data-id="element-335">
                      {formatNaira(claim.amount)}
                    </td>
                    <td className="px-6 py-4" data-id="element-336">
                      <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${claim.status === 'Settled' ? 'bg-emerald-100 text-emerald-700' : claim.status === 'Under Review' ? 'bg-amber-100 text-amber-700' : 'bg-blue-100 text-blue-700'}`} data-id="element-337">
                        {claim.status === 'Settled' ? <CheckCircleIcon className="w-3.5 h-3.5" data-id="element-338" /> : <ClockIcon className="w-3.5 h-3.5" data-id="element-339" />}
                        {claim.status}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden flex flex-col" data-id="element-340">
          <div className="px-6 py-5 border-b border-gray-100" data-id="element-341">
            <h3 className="font-bold text-[#0D3B3B] flex items-center gap-2" data-id="element-342">
              <AlertCircleIcon className="w-5 h-5 text-amber-500" data-id="element-343" /> Action
              Required
            </h3>
          </div>
          <div className="p-6 flex-1 flex flex-col gap-4" data-id="element-344">
            <div className="border border-gray-100 rounded-xl p-4 hover:border-[#2BA89D] transition-colors cursor-pointer" data-id="element-345">
              <div className="flex justify-between items-start mb-2" data-id="element-346">
                <div data-id="element-347">
                  <h4 className="font-bold text-[#0D3B3B] text-sm" data-id="element-348">
                    Pending Underwriter Registration
                  </h4>
                  <p className="text-xs text-gray-500" data-id="element-349">
                    89 plans await offline registration
                  </p>
                </div>
                <span className="bg-amber-100 text-amber-700 px-2 py-1 rounded-md text-xs font-bold" data-id="element-350">
                  High Priority
                </span>
              </div>
            </div>
            <div className="border border-gray-100 rounded-xl p-4 hover:border-[#2BA89D] transition-colors cursor-pointer" data-id="element-351">
              <div className="flex justify-between items-start mb-2" data-id="element-352">
                <div data-id="element-353">
                  <h4 className="font-bold text-[#0D3B3B] text-sm" data-id="element-354">
                    Unsettled Claims
                  </h4>
                  <p className="text-xs text-gray-500" data-id="element-355">
                    12 claims approved but pending payout
                  </p>
                </div>
                <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded-md text-xs font-bold" data-id="element-356">
                  Review
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}